module.exports = __webpack_public_path__ + "img/title.223bb70e.png";